import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { VbBaseMenuComponent } from '../shared/VbBaseMenu.Component';
import { ReactionCfg } from './ReactionCfg';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { Subscription } from 'rxjs';

import { VbHotkeysService } from '../hotkeys/VbHotkeys.Service';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import { VBRICK_PLAYER_HOST } from '../VbPlayerHostToken';

@Component({
	selector: 'reactions-menu',
	template: `
		<div dropdown
			#dropdown="bs-dropdown"
			placement="top right"
			[dropup]="true"
			[insideClick]="true">

			<button
				class="menuButton vb-icon vb-icon-smile-plus"
				type="button"
				dropdownToggle
				vbControlBarFocus
				[attr.aria-label]="translations.reactions"
				[tooltip]="translations.reactions">

			</button>

			<div class="reactionsDropdownMenu dropdown-menu dropdownMenu"
				tabindex="0"
				*dropdownMenu
				#vbDropdownMenu
				role="menu">
				<div class="menuContent">

					<div class="emojiWrap">
					@for(emoji of reactionCfg.emojis; track $index) {
						<button
							type="button"
							class="emojiBtn"
							[disabled]="timeout"
							[tooltip]="timeout ? translations.reactionsTimeout : emoji.name"
							(click)="addReaction(emoji.char)">
							{{ emoji.char }}
						</button>
					}
					</div>
					<div class="enabledWrap">

						<div class="btn-group"
							role="group"
							container="body"
							[tooltip]="translations.showHideReactions">
							<button type="button"
								[class.btn-primary]="!reactionCfg.hidden"
								[disabled]="!reactionCfg.hidden"
								class="btn"
								(click)="setHidden(false)">
								<span class="vb-icon vb-icon-round-check"></span>
								{{translations.show}}
							</button>
							<button type="button"
								[class.btn-primary]="reactionCfg.hidden"
								[disabled]="reactionCfg.hidden"
								class="btn"
								(click)="setHidden(true)">
								<span class="vb-icon vb-icon-round-check"></span>
								{{translations.hide}}</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	`,
	standalone: false,
	styleUrls: ['./ReactionsMenu.Component.ng.less', '../MenuButton.ng.less']
})
export class ReactionsMenuComponent extends VbBaseMenuComponent implements OnDestroy, OnInit {
	@Input() public translations: any;
	@Input() public reactionCfg: ReactionCfg;

	@Output() public onReactionAdded = new EventEmitter<string>();
	@Output() public onReactionsHidden = new EventEmitter<boolean>();

	@ViewChild('dropdown') public dropdown: BsDropdownDirective;
	@ViewChildren(TooltipDirective) public tooltips: QueryList<TooltipDirective>;

	public timeout: number;
	public sub: Subscription;

	constructor(
		@Inject(VBRICK_PLAYER_HOST)
		private readonly player: any,
		private readonly VbHotkeysService: VbHotkeysService
	) {
		super();
	}

	public ngOnInit(): void {
		super.ngOnInit();
		this.sub = this.VbHotkeysService.registerHotkey(
			{ keys: 'r', description: this.translations.reactions + ' (r)' },
			this.player.config.ignoreHotkeys
		)
			.subscribe({
				next: () => this.dropdown.isOpen ? this.dropdown.hide() : this.dropdown.show(),
				error: e => console.error('Hotkey error', e)
			});
	}

	public ngOnDestroy(): void {
		super.ngOnDestroy();
		this.sub?.unsubscribe();
	}

	public addReaction(ch): void {
		this.dropdown.hide();
		this.onReactionAdded.emit(ch);
		const delay = this.reactionCfg.delaySeconds;
		if(delay > 0) {
			this.timeout = window.setTimeout(() => {
				this.timeout = undefined;
				this.hideTooltips();
			}, delay * 1000);
			this.hideTooltips();
		}
	}

	public setHidden(isHidden): void {
		if(this.reactionCfg.hidden !== isHidden) {
			this.onReactionsHidden.emit(isHidden);
		}
	}

	private hideTooltips(): void {
		this.tooltips.forEach(t => t.hide());
	}
}
